const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/schedulingPlan.ts';
import { loadSchedulingPlans, REQUEST_ACTION_TYPES_LOAD_SCHEDULING_PLANS } from 'App/actions/schedulingPlan';
import {
    getData,
    getDataFromPayloadWithListObject,
    makeReducer2,
    useRemoteData2,
} from '@cistec/common_web/utils/redux4Requests';
import { Plan } from 'App/defs/types';
import { PatAppStoreState } from './setup/rootReducer';
import _ from 'lodash';
import { createSelector } from 'reselect';
// REDUCER

export const schedulingPlansReducer = makeReducer2([
    [REQUEST_ACTION_TYPES_LOAD_SCHEDULING_PLANS, undefined, getDataFromPayloadWithListObject],
]);

// SELECTORS

const selectSchedulingPlans = (state: PatAppStoreState): Plan[] | undefined => getData(state.schedulingPlan);
const selectSchedulingPlan = (state: PatAppStoreState) => getData(state.schedulingPlan);

export const selectAllTreatmentReasons = createSelector([selectSchedulingPlan], (plans): string[] => {
    if (!plans) return [];
    const treatmentReasons: string[] = [];
    Object.values(plans).forEach((plan: any) => {
        plan.treatmentReasons.forEach((treatmentReasonPerPlan: any) =>
            treatmentReasons.push(treatmentReasonPerPlan.Key)
        );
    });

    return _.uniq(treatmentReasons);
});

// HOOKS

export const useSchedulingPlans = () => {
    return useRemoteData2('schedulingPlan', {
        request: dispatch => dispatch(loadSchedulingPlans()),
        select: selectSchedulingPlans,
    });
};

export const useAllTreatmentResons = () => {
    return useRemoteData2('schedulingPlan', {
        request: dispatch => dispatch(loadSchedulingPlans()),
        select: selectAllTreatmentReasons,
    });
};
